import {
  CustomerAddress,
  CustomerUserDetails,
  OrderDelivery,
} from '@ancon/wildcat-types'
import getFullName from '@ancon/wildcat-utils/user/getFullName'

export default function getCheckoutDeliveryDetails(
  customerAddress?: CustomerAddress,
  profileData?: CustomerUserDetails | null,
): OrderDelivery | undefined {
  if (!customerAddress) return undefined

  return {
    address: customerAddress || null,
    phone: (profileData ? profileData.telephoneNumber : '') || '',
    recipient: getFullName(profileData) || '',
  }
}
